var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import APInput from '../common/APInput';
import APButton from '../common/APButton';
import APIcon from '../common/APIcon';
import { required } from '../../helpers/formValidations';
import APPasswordInput from '../common/APPasswordInput/APPasswordInput';
import redirectIfAuthorized from '../../hocs/redirectIfAuthorized';
import { defaultPath } from '../../routeTemplates';
import path from '../../helpers/path';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import TradingServerComponent from '../TradingServer/TradingServerComponent';
import { styleNames } from '../../propTypes/commonComponent';
import '../../styles/components/common/StandaloneForm.css';
import './LoginFormComponent.css';
var baseClasses = getBEMClasses('standalone-form');
var loginFormClasses = getBEMClasses('login-form');
export var LoginFormComponent = function LoginFormComponent(props, context) {
  var handleSubmit = props.handleSubmit,
    errorMsg = props.errorMsg,
    submitting = props.submitting,
    doSubmit = props.doSubmit,
    isConnected = props.isConnected,
    useEmailAsUsername = props.useEmailAsUsername,
    active = props.active,
    siteName = props.siteName,
    gateway = props.gateway,
    formGateway = props.formGateway,
    resetForm = props.resetForm;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    customGateway = _useState2[0],
    setCustomGateway = _useState2[1];
  if (formGateway === 'CUSTOM' && !customGateway) {
    setCustomGateway(true);
    resetForm('gateway');
  }
  return React.createElement('div', {
    className: baseClasses('container') + ' ' + loginFormClasses('container')
  }, React.createElement('div', {
    className: baseClasses('header') + ' ' + loginFormClasses('header')
  }, React.createElement('div', {
    className: baseClasses('header-text') + ' ' + loginFormClasses('header-text')
  }, context.t('Log In to {n}', {
    n: siteName
  })), React.createElement(Link, {
    to: path('/'),
    className: baseClasses('close-icon')
  }, React.createElement(APIcon, {
    name: 'close',
    classModifiers: 'big'
  }))), React.createElement('form', {
    onSubmit: handleSubmit(function (values) {
      return doSubmit(values, isConnected);
    }),
    className: baseClasses('form') + ' ' + loginFormClasses('form')
  }, errorMsg && React.createElement('p', {
    className: baseClasses('error')
  }, errorMsg), React.createElement(APInput, {
    type: 'text',
    name: 'username',
    customClass: loginFormClasses(),
    label: useEmailAsUsername ? context.t('Email') : context.t('Username'),
    validate: [required]
  }), React.createElement(APPasswordInput, {
    type: 'password',
    name: 'password',
    customClass: loginFormClasses(),
    label: context.t('Password'),
    validate: [required]
  }), (!gateway || customGateway) && React.createElement(APInput, {
    type: 'text',
    name: 'gateway',
    customClass: loginFormClasses(),
    label: context.t('Gateway'),
    validate: [required]
  }), !customGateway && Array.isArray(gateway) && React.createElement(TradingServerComponent, null), React.createElement('hr', {
    className: loginFormClasses('separator')
  }), React.createElement(APButton, {
    type: 'submit',
    disabled: submitting,
    customClass: loginFormClasses(),
    styleName: styleNames.additive
  }, submitting ? context.t('Processing...') : context.t('Log In'))), React.createElement('div', {
    className: baseClasses('footer') + ' ' + loginFormClasses('footer')
  }, active && React.createElement(React.Fragment, null, React.createElement(Link, {
    to: path('/signup'),
    className: loginFormClasses('link'),
    disabled: true
  }, context.t('Sign Up')), React.createElement('div', {
    className: baseClasses('footer-separator')
  })), React.createElement(Link, {
    to: path('/problem-logging-in'),
    className: loginFormClasses('link'),
    disabled: true
  }, context.t('Problem Logging In?'))));
};
LoginFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
LoginFormComponent.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  referrer: PropTypes.string
};
LoginFormComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default redirectIfAuthorized(LoginFormComponent, defaultPath.path);